<mat-grid-list cols="2">
    <mat-grid-tile>
        <mat-card>
            <mat-card-title>
                {{helpingCard.title | translate}}
            </mat-card-title>
            <mat-card-content>
                {{helpingCard.text | translate}}
            </mat-card-content>
            <img mat-card-image class="genio" [src]="helpingCard.image" alt="{{'signup.wizard' | translate}}">
  
        </mat-card>


    </mat-grid-tile>
    <mat-grid-tile>
        <mat-vertical-stepper (selectionChange)="nextStep($event)" [linear]="isLinear" #stepper>
            <mat-step [stepControl]="usernameFormGroup">
                    <div  
                    class="usernametaken"
                    *ngIf="usernameFormGroup.controls.usernameCtrl.errors && usernameFormGroup.controls.usernameCtrl.errors.usernameTaken">
                            {{'signup.usernameexists' | translate}}
                    </div> 
                <form [formGroup]="usernameFormGroup">
                    <ng-template matStepLabel>{{'signup.usernameexists' | translate}}</ng-template>

                    <mat-form-field>
                        <input matInput placeholder="{{'signup.nouserreal' | translate}}" formControlName="usernameCtrl" required>
                    </mat-form-field>
                    <br>
                    <mat-form-field>
                        <input type="password" matInput placeholder="password" formControlName="passwordCtrl" required>
                    </mat-form-field>
                    <div>
                        <button  mat-button matStepperNext>{{'signup.next' | translate}}</button>
                    </div>
                </form>
            </mat-step>
            <mat-step [stepControl]="emailFormGroup">
                <form [formGroup]="emailFormGroup">
                    <ng-template matStepLabel>{{'signup.youremail' | translate}}</ng-template>
                    <mat-form-field>
                        <input type="email" email="true" matInput placeholder="email" formControlName="emailCtrl"
                            required>
                    </mat-form-field>
                    <div>
                        <button mat-button matStepperNext>{{'signup.next' | translate}}</button>
                        <button mat-button matStepperPrevious>{{'signup.back' | translate}}</button>
                    </div>
                </form>
            </mat-step>
            <mat-step [stepControl]="birthdateFormGroup">
                <form [formGroup]="birthdateFormGroup">
                    <ng-template matStepLabel>{{'signup.birthdate' | translate}}</ng-template>
                    <mat-form-field>
                        <mat-select placeholder="{{'signup.month.hint' | translate}}" formControlName="monthCtrl" required>
                            <mat-option *ngFor="let m of months" [value]="m.value">
                                {{m.viewValue | translate}}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>/
                    <mat-form-field>
                        <mat-select placeholder="{{'signup.year.hint' | translate}}" formControlName="yearCtrl" required>
                            <mat-option *ngFor="let y of years" [value]="y">
                                {{y}}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                    <div>
                        <button mat-button matStepperNext>{{'signup.next' | translate}}</button>
                        <button mat-button matStepperPrevious>{{'signup.back' | translate}}</button>
                    </div>
                </form>
            </mat-step>
            <mat-step [stepControl]="genderFormGroup">
                <form [formGroup]="genderFormGroup">
                    <ng-template matStepLabel>{{'signup.sex' | translate}}</ng-template>
                    <mat-form-field>
                        <mat-select placeholder="{{'signup.sex.hint' | translate}}" formControlName="genderCtrl" required>
                            <mat-option *ngFor="let g of genders" [value]="g.value">
                                {{g.viewValue | translate}}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                    <div>
                        <button mat-button matStepperNext>{{'signup.next' | translate}}</button>
                        <button mat-button matStepperPrevious>{{'signup.back' | translate}}</button>
                    </div>
                </form>
            </mat-step>

            <mat-step>
                <ng-template matStepLabel>{{'signup.ready' | translate}}</ng-template>

                <div>
                    <button (click)="startLML()" mat-button>{{'signup.startusinglml' | translate}}</button>
                </div>
            </mat-step>
        </mat-vertical-stepper>
    </mat-grid-tile>

</mat-grid-list>